var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"copy",on:{"click":function($event){$event.preventDefault();return _vm.clearFailed()}}},[_c('span',[_vm._v(_vm._s(_vm.$t('ui.clear')))]),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.cleared),expression:"cleared"}],staticClass:"UI-icon UI-checked"})])
}
var staticRenderFns = []

export { render, staticRenderFns }